/**
 * Display-only hours format from VITE_HOURS_FORMAT (12 | 24).
 * API payloads and availability math stay on 24-hour HH:mm — do not use this for saves.
 */
export type HoursFormat = '12' | '24';

export function getHoursFormat(): HoursFormat {
  const raw = String(import.meta.env.VITE_HOURS_FORMAT ?? '24').trim();
  return raw === '12' ? '12' : '24';
}

export function is12HourDisplay(): boolean {
  return getHoursFormat() === '12';
}

/** Intl.DateTimeFormat hour12 flag for user-facing labels. */
export function getDisplayHour12(): boolean {
  return is12HourDisplay();
}

export function getIntlTimeFormatOptions(
  base: Intl.DateTimeFormatOptions = {},
): Intl.DateTimeFormatOptions {
  const opts: Intl.DateTimeFormatOptions = {
    ...base,
    hour12: is12HourDisplay(),
  };
  // Normalize the hour style so it matches the date-fns tokens (h:mm a vs HH:mm):
  // 12-hour shows a no-leading-zero hour ("6:00 PM"); 24-hour zero-pads ("06:00").
  if (opts.hour) {
    opts.hour = is12HourDisplay() ? 'numeric' : '2-digit';
  }
  return opts;
}
